import { sourceImage } from "../../utils/source-image.js";
import { getApiUrl } from "../../services/apiConfig.js";
(() => {
  "use strict";

  const handleAction = (tag, cls, text) => {
    const createElementResult = document.createElement(tag);
    if (cls) createElementResult.className = cls;
    if (text !== undefined) createElementResult.textContent = String(text);
    return createElementResult;
  };
  const handleActionAtual2 = (text, click, cls = "im-button") => {
    const handleActionResult = handleAction("button", cls, text);
    handleActionResult.type = "button";
    handleActionResult.addEventListener("click", click);
    return handleActionResult;
  };
  const handleActionAtual3 = (name, type = "text", value = "") => {
    const wrap = handleAction("label", "im-field"),
      label = handleAction("span", null, name),
      input = handleAction("input");
    input.type = type;
    input.value = value ?? "";
    wrap.append(label, input);
    return {
      wrap,
      input,
    };
  };
  const number = (value) =>
    Number(value || 0).toLocaleString("pt-BR", {
      maximumFractionDigits: 3,
    });
  const hours = (value) =>
    (Number(value || 0) / 3600).toLocaleString("pt-BR", {
      maximumFractionDigits: 1,
    }) + " h";
  const titles = {
    feed: "Feed",
    questoes: "Questões a resolver",
    bonus: "Bônus e penalidades",
    cardapio: "Cardápio",
    loja: "Recompensas",
    salas: "Salas",
    bloqueios: "Bloqueios",
    agendar: "Agendamentos",
    desafios: "Desafios",
    resgates: "Resgates",
    meritos: "Méritos",
  };
  function sessionNow() {
    try {
      return JSON.parse(sessionStorage.getItem("auth_session") || "null") || {};
    } catch {
      return {};
    }
  }
  function client(session) {
    let alive = true;
    const pending = new Set();
    const headers = {};
    if (session.tipo === "admin") {
      if (session.data?.token) headers["X-Admin-Token"] = session.data.token;
      if (session.data?.learning_admin_token)
        headers["X-Learning-Token"] = session.data.learning_admin_token;
    } else
      headers.Authorization = "Bearer " + (session.data?.access_token || "");
    return {
      async request(resource, house = 0, params = {}, method = "GET", body) {
        if (!alive) throw Error("Esta tela já foi fechada.");
        const abort = new AbortController();
        pending.add(abort);
        const timer = setTimeout(() => abort.abort(), 15000);
        try {
          const query = new URLSearchParams({
            resource,
            id: house,
            ...params,
          });
          const res = await fetch(
            getApiUrl("/api/institution-management.php?" + query),
            {
              method,
              headers: {
                ...headers,
                ...(body
                  ? {
                      "Content-Type": "application/json",
                    }
                  : {}),
              },
              body: body ? JSON.stringify(body) : undefined,
              signal: abort.signal,
              cache: "no-store",
              credentials: "same-origin",
            },
          );
          const json = await res.json();
          if (!res.ok || json.status !== "success")
            throw Error(
              json.message || "Não foi possível concluir esta operação.",
            );
          return json.data;
        } catch (error) {
          if (error.name === "AbortError")
            throw Error("A solicitação demorou a responder. Tente novamente.");
          throw error;
        } finally {
          clearTimeout(timer);
          pending.delete(abort);
        }
      },
      headers,
      dispose() {
        alive = false;
        pending.forEach((item) => item.abort());
        pending.clear();
      },
    };
  }
  function rootUi(root) {
    root.replaceChildren();
    root.classList.add("im-ui");
    const status = handleAction("p", "im-status");
    status.setAttribute("role", "status");
    status.hidden = true;
    root.append(status);
    return {
      status,
      note(text) {
        status.textContent = text;
        status.hidden = false;
      },
      error(err) {
        status.textContent = err.message || "Não foi possível carregar.";
        status.hidden = false;
      },
    };
  }
  function select(name, items, value = "") {
    const handleActionAtual3Result = handleActionAtual3(name);
    const handleActionResult = handleAction("select");
    for (const [optionalValue, label] of items) {
      const handleActionResultAtual2 = handleAction("option", null, label);
      handleActionResultAtual2.value = optionalValue;
      handleActionResult.append(handleActionResultAtual2);
    }
    handleActionResult.value = value;
    handleActionAtual3Result.wrap.replaceChild(
      handleActionResult,
      handleActionAtual3Result.input,
    );
    return {
      wrap: handleActionAtual3Result.wrap,
      input: handleActionResult,
    };
  }
  function table(headings, rows) {
    const frame = handleAction("div", "im-table-frame"),
      handleActionResult = handleAction("table", "im-table"),
      handleActionResultAtual2 = handleAction("thead"),
      handleActionResultAtual3 = handleAction("tr");
    for (const label of headings)
      handleActionResultAtual3.append(handleAction("th", null, label));
    handleActionResultAtual2.append(handleActionResultAtual3);
    const body = handleAction("tbody");
    for (const row of rows) {
      const handleActionResultAtual4 = handleAction("tr");
      for (const optionalValue of row) {
        const handleActionResultAtual5 = handleAction("td");
        if (optionalValue instanceof Node)
          handleActionResultAtual5.append(optionalValue);
        else handleActionResultAtual5.textContent = optionalValue ?? "—";
        handleActionResultAtual4.append(handleActionResultAtual5);
      }
      body.append(handleActionResultAtual4);
    }
    handleActionResult.append(handleActionResultAtual2, body);
    frame.append(handleActionResult);
    return frame;
  }
  function paging(parent, result, load) {
    const handleActionResult = handleAction("div", "im-pagination");
    handleActionResult.append(
      handleAction(
        "span",
        null,
        result.total +
          " registros · Página " +
          result.page +
          " de " +
          result.totalPages,
      ),
    );
    const prev = handleActionAtual2("Anterior", () => load(result.page - 1)),
      next = handleActionAtual2("Próxima", () => load(result.page + 1));
    prev.disabled = result.page <= 1;
    next.disabled = result.page >= result.totalPages;
    handleActionResult.append(prev, next);
    parent.append(handleActionResult);
  }
  function report(root) {
    const session = sessionNow(),
      api = client(session),
      rootUiResult = rootUi(root);
    let alive = true,
      generation = 0,
      portalCleanup = null;
    const tools = handleAction("form", "im-toolbar im-report-toolbar");
    const search = handleActionAtual3("Pesquisar instituição"),
      from = handleActionAtual3("De", "date"),
      until = handleActionAtual3("Até", "date");
    tools.append(search.wrap, from.wrap, until.wrap);
    const apply = handleAction("button", "im-button", "Pesquisar");
    apply.type = "submit";
    tools.append(apply);
    const view = handleAction("div");
    root.append(tools, view);
    tools.addEventListener("submit", (event) => {
      event.preventDefault();
      load(1);
    });
    async function load(page = 1) {
      const epoch = ++generation;
      rootUiResult.status.hidden = true;
      view.textContent = "Carregando relatório…";
      try {
        const requestResult = await api.request("report", 0, {
          q: search.input.value,
          from: from.input.value,
          until: until.input.value,
          page,
          limit: 20,
        });
        if (!alive || epoch !== generation) return;
        view.replaceChildren();
        const totals = handleAction("div", "im-metrics");
        for (const [label, key] of [
          ["Instituições nesta página", "institutions"],
          ["Alunos", "students_count"],
          ["Professores", "teachers_count"],
          ["Horas de estudo", "study_seconds"],
        ]) {
          const value =
            key === "institutions"
              ? requestResult.items.length
              : requestResult.page_totals[key] || 0;
          const item = handleAction("div");
          item.append(
            handleAction("span", null, label),
            handleAction(
              "strong",
              null,
              key === "study_seconds" ? hours(value) : number(value),
            ),
          );
          totals.append(item);
        }
        view.append(totals);
        const rows = requestResult.items.map((item) => [
          item.nome,
          number(item.students_count),
          number(item.teachers_count),
          number(item.classes_count),
          number(item.accessed_students_count),
          number(item.tasks_count),
          hours(item.study_seconds),
          number(item.closed_count),
          number(item.open_count),
          number(item.flashcards_count),
          hours(item.video_seconds_total),
          handleActionAtual2("Abrir gestão", () => open(item.id)),
        ]);
        view.append(
          table(
            [
              "Instituição",
              "Alunos",
              "Professores",
              "Turmas",
              "Alunos com acesso no período",
              "Tarefas enviadas",
              "Estudo no período",
              "Fechadas",
              "Abertas",
              "Flashcards",
              "Vídeo acumulado",
              "",
            ],
            rows,
          ),
        );
        view.append(
          handleAction(
            "p",
            "im-muted",
            "Questões e flashcards contam a primeira resposta. O tempo de vídeo é o total acumulado; os registros antigos não permitem separar esse tempo por data.",
          ),
        );
        paging(view, requestResult, load);
      } catch (err) {
        if (alive && epoch === generation) {
          view.replaceChildren();
          rootUiResult.error(err);
          view.append(handleActionAtual2("Tentar novamente", () => load(page)));
        }
      }
    }
    function open(value) {
      if (!window.DMInstitutionPortal)
        return rootUiResult.note("Atualize a página para abrir a instituição.");
      ++generation;
      portalCleanup = window.DMInstitutionPortal.mount(root, session, {
        institutionId: Number(value),
        preview: true,
        returnTo: () => {
          portalCleanup?.();
          portalCleanup = null;
          root.replaceChildren(rootUiResult.status, tools, view);
          load();
        },
      });
    }
    load();
    return () => {
      alive = false;
      ++generation;
      api.dispose();
      portalCleanup?.();
      root.replaceChildren();
    };
  }
  function profile(root, session, house, options = {}) {
    const api = client(session),
      rootUiResult = rootUi(root);
    let alive = true,
      photo = null;
    const view = handleAction("div");
    root.append(view);
    async function load() {
      view.textContent = "Carregando perfil…";
      try {
        const requestResult = await api.request("profile", house);
        if (!alive) return;
        view.replaceChildren();
        const card = handleAction("section", "im-card"),
          head = handleAction("div", "im-profile-head");
        const img = handleAction("img", "im-profile-image");
        img.alt = requestResult.nome;
        img.src = requestResult.imagem
          ? sourceImage(requestResult.imagem)
          : "data:image/svg+xml," +
            encodeURIComponent(
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><rect width="80" height="80" rx="40" fill="#e7f3f1"/><path d="M19 59h42M24 59V28l16-10 16 10v31M35 59V43h10v16M33 30v5m14-5v5" fill="none" stroke="#4fb3a9" stroke-width="4"/></svg>',
            );
        head.append(img, handleAction("h2", null, requestResult.nome));
        card.append(head);
        const form = handleAction("form", "im-form"),
          responsible = handleActionAtual3(
            "Nome do responsável",
            "text",
            requestResult.responsible_name,
          ),
          image = handleActionAtual3("Foto da instituição", "file");
        image.input.accept = "image/png,image/jpeg,image/gif,image/webp";
        image.input.addEventListener("change", async () => {
          const file = image.input.files?.[0];
          if (!file) return;
          if (
            !["image/png", "image/jpeg", "image/gif", "image/webp"].includes(
              file.type,
            ) ||
            file.size > 5242880
          ) {
            rootUiResult.note("Escolha uma imagem de até 5 MB.");
            return;
          }
          const reader = new FileReader();
          reader.onload = () => {
            if (alive) {
              photo = reader.result;
              img.src = photo;
            }
          };
          reader.onerror = () =>
            rootUiResult.note("Não foi possível ler a imagem.");
          reader.readAsDataURL(file);
        });
        form.append(responsible.wrap, image.wrap);
        const save = handleAction("button", "im-button", "Salvar perfil");
        save.type = "submit";
        form.append(save);
        card.append(form);
        form.addEventListener("submit", async (event) => {
          event.preventDefault();
          save.disabled = true;
          try {
            const data = {
              responsible_name: responsible.input.value,
            };
            if (photo) data.photo = photo;
            const result = await api.request("profile", house, {}, "PUT", data);
            if (alive) {
              photo = null;
              rootUiResult.note("Perfil salvo.");
              options.onSaved?.(result);
            }
          } catch (error) {
            if (alive) rootUiResult.error(error);
          } finally {
            if (alive) save.disabled = false;
          }
        });
        view.append(card);
        const auth = handleAction("section", "im-card");
        auth.append(handleAction("h3", null, "Acesso da instituição"));
        const handleActionResult = handleAction("form", "im-form"),
          login = handleActionAtual3("Login", "text", requestResult.login),
          current = handleActionAtual3("Senha atual", "password"),
          password = handleActionAtual3("Nova senha", "password"),
          confirm = handleActionAtual3("Confirmar nova senha", "password");
        current.input.autocomplete = "current-password";
        password.input.autocomplete = confirm.input.autocomplete =
          "new-password";
        password.input.minLength = confirm.input.minLength = 6;
        password.input.maxLength = confirm.input.maxLength = 72;
        password.input.placeholder = "Mínimo de 6 caracteres";
        login.input.required = current.input.required = true;
        handleActionResult.append(
          login.wrap,
          current.wrap,
          password.wrap,
          confirm.wrap,
        );
        handleActionResult.append(
          handleAction(
            "p",
            "im-muted",
            "Para trocar somente o login, deixe a nova senha em branco. Ao salvar uma troca de acesso, entre novamente.",
          ),
        );
        const update = handleAction("button", "im-button", "Atualizar acesso");
        update.type = "submit";
        update.disabled = !requestResult.login;
        handleActionResult.append(update);
        auth.append(handleActionResult);
        view.append(auth);
        handleActionResult.addEventListener("submit", async (event) => {
          event.preventDefault();
          if (password.input.value !== confirm.input.value)
            return rootUiResult.note("As senhas não conferem.");
          update.disabled = true;
          try {
            const result = await api.request("profile", house, {}, "POST", {
              action: "credentials",
              login: login.input.value,
              current_password: current.input.value,
              new_password: password.input.value,
              confirm_password: confirm.input.value,
            });
            current.input.value =
              password.input.value =
              confirm.input.value =
                "";
            if (!alive) return;
            rootUiResult.note(
              result.changed
                ? "Acesso atualizado. Entre novamente com as novas informações."
                : "As informações de acesso foram mantidas.",
            );
            if (result.changed && session.tipo === "instituicao") {
              sessionStorage.removeItem("auth_session");
              view.replaceChildren(
                handleActionAtual2("Entrar novamente", () => {
                  window.location.hash = "/login-aluno";
                  window.location.reload();
                }),
              );
            }
          } catch (error) {
            if (alive) rootUiResult.error(error);
          } finally {
            if (alive) update.disabled = false;
          }
        });
      } catch (error) {
        if (alive) {
          view.replaceChildren();
          rootUiResult.error(error);
          view.append(handleActionAtual2("Tentar novamente", load));
        }
      }
    }
    load();
    return () => {
      alive = false;
      photo = null;
      api.dispose();
      root.replaceChildren();
    };
  }
  function operations(root, session, house, key, options = {}) {
    const api = client(session),
      rootUiResult = rootUi(root);
    let alive = true,
      generation = 0,
      page = 1,
      formCleanup = null;
    const toolbar = handleAction("form", "im-toolbar"),
      search = handleActionAtual3("Pesquisar"),
      limit = select(
        "Por página",
        [
          [20, "20"],
          [50, "50"],
        ],
        20,
      ),
      area = handleAction("div"),
      formArea = handleAction("section");
    toolbar.append(search.wrap, limit.wrap);
    const handleActionResult = handleAction("button", "im-button", "Pesquisar");
    handleActionResult.type = "submit";
    toolbar.append(handleActionResult);
    root.append(toolbar, formArea, area);
    toolbar.addEventListener("submit", (event) => {
      event.preventDefault();
      load(1);
    });
    const catalog = ["cardapio", "loja", "salas", "bloqueios"];
    if (catalog.includes(key))
      toolbar.append(handleActionAtual2("Novo cadastro", () => edit({})));
    if (key === "bonus")
      toolbar.append(
        handleActionAtual2("Adicionar bônus ou penalidade", () => bonusForm()),
      );
    if (key === "agendar")
      toolbar.append(
        handleActionAtual2("Novo agendamento", () => appointmentForm()),
        handleActionAtual2("Salas", () => options.navigate?.("salas")),
        handleActionAtual2("Bloqueios", () => options.navigate?.("bloqueios")),
      );
    if (key === "loja")
      toolbar.append(
        handleActionAtual2("Ver resgates", () =>
          options.navigate?.("resgates"),
        ),
      );
    async function mutate(body, resource = key) {
      try {
        await api.request(resource, house, {}, "POST", body);
        if (alive) {
          rootUiResult.note("Alteração registrada.");
          clearForm();
          await load(page);
        }
      } catch (error) {
        if (alive) rootUiResult.error(error);
      }
    }
    function clearForm() {
      formCleanup?.();
      formCleanup = null;
      formArea.replaceChildren();
    }
    function buttons(row) {
      const group = handleAction("div", "im-actions");
      if (catalog.includes(key)) {
        group.append(handleActionAtual2("Editar", () => edit(row)));
        const active =
          Number(row.management_active) !== 0 && Number(row.ativo ?? 1) !== 0;
        group.append(
          handleActionAtual2(active ? "Desativar" : "Reativar", () =>
            mutate({
              action: "status",
              item_id: row.id,
              active: active ? 0 : 1,
            }),
          ),
        );
      }
      if (key === "questoes" && row.status_questao === "pendente")
        group.append(handleActionAtual2("Analisar", () => decision(row)));
      if (key === "agendar")
        group.append(
          handleActionAtual2(
            row.status === "cancelado" ? "Confirmar" : "Cancelar",
            () =>
              mutate({
                action: "status",
                item_id: row.id,
                status: row.status === "cancelado" ? "confirmado" : "cancelado",
              }),
          ),
        );
      if (key === "desafios" && ["aguardando", "aceita"].includes(row.status))
        group.append(
          handleActionAtual2("Cancelar", () =>
            mutate({
              action: "status",
              item_id: row.id,
              status: "cancelada",
            }),
          ),
        );
      if (key === "desafios" && row.status === "aceita")
        group.append(
          handleActionAtual2("Finalizar", () =>
            mutate({
              action: "finalize",
              item_id: row.id,
            }),
          ),
        );
      if (key === "resgates" && row.status === "pendente")
        group.append(
          handleActionAtual2("Aprovar", () =>
            mutate({
              action: "status",
              item_id: row.id,
              status: "aprovado",
            }),
          ),
          handleActionAtual2("Cancelar", () =>
            mutate({
              action: "status",
              item_id: row.id,
              status: "cancelado",
            }),
          ),
        );
      return group;
    }
    async function load(next = 1) {
      page = next;
      const epoch = ++generation;
      area.textContent = "Carregando…";
      try {
        const requestResult = await api.request(key, house, {
          page,
          limit: limit.input.value,
          q: search.input.value,
        });
        if (!alive || epoch !== generation) return;
        area.replaceChildren();
        const rows = requestResult.items.map((row) => {
          if (catalog.includes(key))
            return [
              row.nome || row.motivo,
              row.categoria || row.tipo || "Sala",
              key === "salas"
                ? number(row.capacidade)
                : row.custo_token !== undefined
                  ? number(row.custo_token) + " tokens"
                  : row.data_especifica || "Semanal",
              Number(row.management_active) === 0 ||
              Number(row.ativo ?? 1) === 0
                ? "Desativado"
                : "Ativo",
              buttons(row),
            ];
          if (key === "meritos")
            return [row.titulo, row.descricao || row.desc, number(row.meta)];
          if (key === "desafios")
            return [
              row.desafiante_nome + " × " + row.desafiado_nome,
              row.criterio_label || row.criterio,
              row.data_inicio + " a " + row.data_fim,
              row.status,
              buttons(row),
            ];
          if (key === "feed" || key === "questoes")
            return [
              row.aluno_nome,
              row.data_estudo,
              row.observacao || "Registro de estudo",
              number(row.pontos_rank) + " pontos",
              row.status_questao || "Registrado",
              buttons(row),
            ];
          if (key === "bonus")
            return [
              row.aluno_nome,
              row.data,
              row.motivo,
              number(row.ranking_points) +
                " pontos · " +
                number(row.tokens) +
                " tokens",
              row.tipo,
            ];
          if (key === "agendar")
            return [
              row.aluno_nome,
              row.data,
              row.periodo,
              row.sala_nome || "Sala",
              row.status,
              buttons(row),
            ];
          return [
            row.aluno_nome,
            row.item_nome,
            number(row.pontos) + " tokens",
            row.data,
            row.status,
            buttons(row),
          ];
        });
        const headings = catalog.includes(key)
          ? ["Nome", "Tipo", "Quantidade", "Status", ""]
          : key === "meritos"
            ? ["Mérito", "Descrição", "Meta"]
            : key === "desafios"
              ? ["Alunos", "Critério", "Período", "Status", ""]
              : ["Aluno", "Data", "Informação", "Quantidade", "Status", ""];
        area.append(table(headings, rows));
        if (!requestResult.items.length)
          area.append(
            handleAction("p", "im-muted", "Nenhum registro encontrado."),
          );
        paging(area, requestResult, load);
      } catch (error) {
        if (alive && epoch === generation) {
          area.replaceChildren();
          rootUiResult.error(error);
          area.append(handleActionAtual2("Tentar novamente", () => load(page)));
        }
      }
    }
    function edit(row) {
      clearForm();
      const form = handleAction("form", "im-card im-form");
      form.append(
        handleAction("h3", null, row.id ? "Editar cadastro" : "Novo cadastro"),
      );
      const fields = {};
      let photo = null;
      function add(label, key, type = "text", defaultValue = "") {
        const handleActionAtual3Result = handleActionAtual3(
          label,
          type,
          row[key] ?? defaultValue,
        );
        form.append(handleActionAtual3Result.wrap);
        fields[key] = handleActionAtual3Result.input;
        return handleActionAtual3Result.input;
      }
      if (key !== "bloqueios") add("Nome", "nome");
      if (key === "salas") add("Capacidade", "capacidade", "number", 1);
      if (["cardapio", "loja"].includes(key)) {
        if (key === "cardapio") {
          const selectResult = select(
            "Categoria",
            [
              ["salgado", "Salgado"],
              ["doce", "Doce"],
              ["bebida", "Bebida"],
            ],
            row.categoria || "salgado",
          );
          form.append(selectResult.wrap);
          fields.categoria = selectResult.input;
          add("Preço em reais", "preco", "number", "0");
        }
        add("Custo em tokens", "custo_token", "number", "0");
        add("Estoque", "estoque", "number", 0);
        add("Descrição", "descricao");
        const file = add("Foto", "photo", "file");
        file.accept = "image/png,image/jpeg,image/gif,image/webp";
        file.addEventListener("change", () => {
          const value = file.files?.[0];
          if (!value) return;
          if (value.size > 5242880)
            return rootUiResult.note("A foto pode ter até 5 MB.");
          const reader = new FileReader();
          reader.onload = () => {
            photo = reader.result;
          };
          reader.readAsDataURL(value);
        });
      }
      if (key === "bloqueios") {
        const kind = select(
          "Tipo",
          [
            ["unico", "Uma data"],
            ["recorrente", "Semanal"],
          ],
          row.tipo || "unico",
        );
        form.append(kind.wrap);
        fields.tipo = kind.input;
        const room = select(
          "Sala",
          [["", "Todas as salas"]],
          row.sala_id || "",
        );
        form.append(room.wrap);
        fields.sala_id = room.input;
        api
          .request("salas", house, {
            limit: 50,
          })
          .then((result) => {
            if (alive) {
              for (const item of result.items) {
                const opt = handleAction("option", null, item.nome);
                opt.value = item.id;
                room.input.append(opt);
              }
              room.input.value = row.sala_id || "";
            }
          })
          .catch(rootUiResult.error);
        add("Data", "data_especifica", "date");
        const days = select(
          "Dia da semana",
          [
            [0, "Domingo"],
            [1, "Segunda"],
            [2, "Terça"],
            [3, "Quarta"],
            [4, "Quinta"],
            [5, "Sexta"],
            [6, "Sábado"],
          ],
          row.dia_semana || 0,
        );
        form.append(days.wrap);
        fields.dia_semana = days.input;
        const period = select(
          "Período",
          [
            ["", "Todo o dia"],
            ["tarde", "Tarde"],
            ["noite", "Noite"],
          ],
          row.periodo || "",
        );
        form.append(period.wrap);
        fields.periodo = period.input;
        add("Motivo", "motivo");
      }
      for (const input of Object.values(fields))
        if (input.type === "number") {
          input.min = "0";
          input.step = ["preco", "custo_token"].includes(
            Object.keys(fields).find((item) => fields[item] === input),
          )
            ? "0.001"
            : "1";
        }
      const save = handleAction("button", "im-button", "Salvar");
      save.type = "submit";
      form.append(save, handleActionAtual2("Cancelar", clearForm));
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        save.disabled = true;
        const data = {
          action: "save",
          item_id: row.id || 0,
        };
        for (const [optionalValue, optionalValueAtual2] of Object.entries(
          fields,
        ))
          if (optionalValue !== "photo")
            data[optionalValue] = optionalValueAtual2.value;
        if (photo) data.photo = photo;
        try {
          await mutate(data);
        } finally {
          save.disabled = false;
        }
      });
      formArea.append(form);
      form.scrollIntoView({
        block: "nearest",
      });
    }
    function studentPicker(form, onPick) {
      const handleActionAtual3Result = handleActionAtual3("Pesquisar aluno"),
        list = handleAction("div", "im-student-picker"),
        chosen = handleAction("p", "im-muted", "Selecione um aluno");
      form.append(
        handleActionAtual3Result.wrap,
        handleActionAtual2("Buscar aluno", () => find(1)),
        chosen,
        list,
      );
      const pending = new Set();
      let active = true,
        epoch = 0;
      async function find(page) {
        const gen = ++epoch;
        const abort = new AbortController();
        pending.add(abort);
        try {
          const res = await fetch(
            getApiUrl(
              "/api/institutions.php?" +
                new URLSearchParams({
                  resource: "students",
                  id: house,
                  q: handleActionAtual3Result.input.value,
                  page,
                  limit: 20,
                }),
            ),
            {
              headers: api.headers,
              signal: abort.signal,
              cache: "no-store",
            },
          );
          const json = await res.json();
          if (!res.ok || json.status !== "success")
            throw Error(json.message || "Não foi possível buscar o aluno.");
          if (!active || gen !== epoch) return;
          list.replaceChildren();
          for (const optionalValue of json.data.items)
            list.append(
              handleActionAtual2(
                optionalValue.nome,
                () => {
                  chosen.textContent = optionalValue.nome;
                  onPick(Number(optionalValue.id));
                  list.replaceChildren();
                },
                "im-student-row",
              ),
            );
          paging(
            list,
            {
              ...json.data,
              totalPages:
                json.data.pagination?.totalPages ||
                Math.max(1, Math.ceil(json.data.total / 20)),
            },
            find,
          );
        } catch (error) {
          if (active && error.name !== "AbortError") rootUiResult.error(error);
        } finally {
          pending.delete(abort);
        }
      }
      return () => {
        active = false;
        ++epoch;
        pending.forEach((item) => item.abort());
      };
    }
    function bonusForm() {
      clearForm();
      const form = handleAction("form", "im-card im-form");
      form.append(handleAction("h3", null, "Bônus ou penalidade"));
      let sid = 0;
      formCleanup = studentPicker(form, (value) => (sid = value));
      const sign = select("Operação", [
          ["add", "Adicionar"],
          ["subtract", "Retirar"],
        ]),
        points = handleActionAtual3("Pontos do ranking", "number", "0"),
        tokens = handleActionAtual3("Tokens", "number", "0"),
        reason = handleActionAtual3("Motivo");
      points.input.min = tokens.input.min = "0";
      points.input.step = tokens.input.step = "0.001";
      form.append(sign.wrap, points.wrap, tokens.wrap, reason.wrap);
      const save = handleAction("button", "im-button", "Registrar");
      save.type = "submit";
      form.append(save, handleActionAtual2("Cancelar", clearForm));
      const requestKey = crypto.randomUUID();
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        if (!sid) return rootUiResult.note("Selecione o aluno.");
        save.disabled = true;
        try {
          await mutate({
            action: "create",
            student_id: sid,
            points:
              (sign.input.value === "subtract" ? "-" : "") + points.input.value,
            tokens:
              (sign.input.value === "subtract" ? "-" : "") + tokens.input.value,
            motivo: reason.input.value,
            request_key: requestKey,
          });
        } finally {
          save.disabled = false;
        }
      });
      formArea.append(form);
    }
    function decision(row) {
      clearForm();
      const form = handleAction("form", "im-card im-form"),
        status = select("Decisão", [
          ["valido", "Validar registro"],
          ["invalido", "Invalidar registro"],
        ]),
        reason = handleActionAtual3("Motivo");
      form.append(
        handleAction("h3", null, row.aluno_nome),
        status.wrap,
        reason.wrap,
      );
      const save = handleAction("button", "im-button", "Registrar decisão");
      save.type = "submit";
      form.append(save, handleActionAtual2("Cancelar", clearForm));
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        mutate({
          action: "decide",
          item_id: row.id,
          status: status.input.value,
          motivo: reason.input.value,
        });
      });
      formArea.append(form);
    }
    function appointmentForm() {
      clearForm();
      const form = handleAction("form", "im-card im-form");
      form.append(handleAction("h3", null, "Novo agendamento"));
      let sid = 0;
      formCleanup = studentPicker(form, (value) => (sid = value));
      const room = select("Sala", [["", "Selecione uma sala"]]),
        date = handleActionAtual3("Data", "date"),
        period = select("Período", [
          ["tarde", "Tarde"],
          ["noite", "Noite"],
        ]),
        guest = handleActionAtual3("Convidado (opcional)");
      form.append(room.wrap, date.wrap, period.wrap, guest.wrap);
      api
        .request("salas", house, {
          limit: 50,
        })
        .then((result) => {
          if (alive)
            for (const row of result.items) {
              if (Number(row.management_active) === 0) continue;
              const opt = handleAction("option", null, row.nome);
              opt.value = row.id;
              room.input.append(opt);
            }
        })
        .catch(rootUiResult.error);
      const save = handleAction("button", "im-button", "Agendar");
      save.type = "submit";
      form.append(save, handleActionAtual2("Cancelar", clearForm));
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        if (!sid) return rootUiResult.note("Selecione o aluno.");
        save.disabled = true;
        try {
          await mutate({
            action: "create",
            student_id: sid,
            sala_id: room.input.value,
            data: date.input.value,
            periodo: period.input.value,
            convidado: guest.input.value,
          });
        } finally {
          if (alive) save.disabled = false;
        }
      });
      formArea.append(form);
    }
    load();
    return () => {
      alive = false;
      ++generation;
      api.dispose();
      formCleanup?.();
      root.replaceChildren();
    };
  }
  window.DMInstitutionProfile = Object.freeze({
    mount: profile,
  });
  window.DMInstitutionOperations = Object.freeze({
    mount: operations,
  });
  window.DMInstitutionAdminReport = Object.freeze({
    mount: report,
  });
})();
